import axios from "axios";
import _ from "lodash";
import { BASE_URI, MOCK_URI, CONTENT_TYPES, buildApiOptions, getRequestKey } from "./apiConstants";
import getApiHeader from "./getApiHeader";
import store from "../redux/store/store";
import { logout } from "../redux/actions";

const config = require("../temp/config");
const service = axios.create();
const apiPromises = {};
const handleBFResponse = res => {
  if (res.status === 200) {
    if (res.data.Data !== undefined && res.data.Data !== null) {
      if (res.data.Data.code === "1") {
        return res.data.Data;
      } else if (res.data.Data.status === 200 || (res.data.Status === 200 && res.data.Data.code === "1")) {
        return res.data.Data;
      } else {
        throw res.data.Data;
      }
    } else if (res.data.code !== undefined) {
      if (res.data.code == "1") {
        return res.data;
      } else {
        if (res.data.obj == 401) {
          store.dispatch(logout());
        } else {
          throw res.data;
        }
      }
    } else {
      if (res.data) return res.data;
      else throw res.data;
    }
  } else throw res;
};
const r = (path, contentType) => {
  return async (params, data, opts) => {
    const key = getRequestKey(path, contentType, params, data, opts);
    //   console.log("request key", key, path);
    if (apiPromises[key]) {
      const res = await apiPromises[key];
      return handleBFResponse(res);
    } else {
      let options = buildApiOptions(path, contentType, params, data, opts);
      const headers = await getApiHeader();
      options.headers = _.merge(headers, options.headers);
      apiPromises[key] = service.request(options);
      const res = await apiPromises[key];
      delete apiPromises[key];
      return handleBFResponse(res);
    }
  };
};
/**
 * @name API Handler FOR BF
 * @param path Request Path
 * @param contentType ContentType
 * @return {APIResolver} API Resolver
 * @typedef BFResponse
 * @property {String} code
 */
const bf = (path, contentType) => {
  return async (params, data, opts) => {
    const key = getRequestKey(path, contentType, params, data, opts);
    // console.log("request key", key, path);
    if (apiPromises[key]) {
      const res = await apiPromises[key];
      return handleBFResponse(res);
    } else {
      let options = buildApiOptions(path, contentType, params, data, opts);
      const headers = await getApiHeader();
      options.headers = _.merge(headers, options.headers);
      apiPromises[key] = service.request(options);
      const res = await apiPromises[key];
      delete apiPromises[key];
      return handleBFResponse(res);
    }
  };
};
/**
 * @name API Handler FOR GEMS
 * @param path Request Path
 * @param contentType ContentType
 * @return {APIResolver} API Resolver
 * @typedef BFResponse
 * @property {String} code
 */
const gems = (path, contentType) => {
  const arr = path.split(" ");
  const host = config.webSettings?.apiHostGems + "/gems/api/v1.0/";
  const newPath = `${arr[0]} ${host}${arr[1]}`;
  return async (params, data, opts) => {
    const key = getRequestKey(newPath, contentType, params, data, opts);
    // if (path === "POST order/shopping-cart/merge") {
    //   debugger;
    // }
    if (apiPromises[key]) {
      const res = await apiPromises[key];
      return handleBFResponse(res);
    } else {
      let options = buildApiOptions(newPath, contentType, params, data, opts);
      const headers = await getApiHeader();
      options.headers = _.merge(headers, options.headers);
      apiPromises[key] = service.request(options);
      const res = await apiPromises[key];
      delete apiPromises[key];
      return handleBFResponse(res);
    }
  };
};
const staticContent = (path, contentType) => {
  const arr = path.split(" ");
  const host = `${config.webSettings?.AZURE_STORAGE_HOST}/web/production/`;
  const newPath = `${arr[0]} ${host}${arr[1]}`;
  return async (params, data, opts) => {
    let options = buildApiOptions(newPath, contentType, params, data, opts);
    const headers = await getApiHeader();
    options.headers = _.merge(headers, options.headers);
    const res = await service.request(options);
    return handleBFResponse(res);
  };
};
const arvato = (path, contentType) => {
  const arr = path.split(" ");
  const host = config.webSettings?.apiHostGems + "/gems/api/v1.0/";
  const newPath = `${arr[0]} ${host}${arr[1]}`;
  return async (params, data, opts) => {
    let options = buildApiOptions(newPath, contentType, params, data, opts);
    const headers = await getApiHeader();
    options.headers = _.merge(headers, options.headers);
    const res = await service.request(options);
    return res.data;
  };
};
const r1 = (path, contentType, apiHost, headers) => {
  const str = path.split(" ");
  const method = str[0];
  let url = str[1];
  if (!/^(http|https)/.test(url)) {
    url = (apiHost || BASE_URI) + url;
  } else if (/^~/.test(url)) {
    url = url.substr(1);
  }
  return (params, body, ops) => {
    if (method === "GET") {
      params = Object.assign(params || {}, {
        _t: Math.floor(Math.random() * 10000000)
      });
    }
    const pathNames = [];
    url = url.replace(/{(\w|_)(\d|\w|_)*}/gi, match => {
      const pathName = match.substr(1, match.length - 2);
      if (pathNames.indexOf(pathName) === -1) {
        pathNames.push(pathName);
      }
      if (params && params[pathName]) {
        return params[pathName];
      }
      if (body && body[pathName]) {
        return body[pathName];
      }
    });
    for (let pathName of pathNames) {
      if (params && params[pathName]) {
        delete params[pathName];
      }
      if (body && body[pathName]) {
        delete body[pathName];
      }
    }
    const options = _.merge({}, ops, {
      method: method,
      url: url,
      params: params,
      data: body,
      headers: headers
    });
    if (contentType) {
      options.headers["Content-Type"] = contentType;
      switch (contentType) {
        case CONTENT_TYPES.file:
          options.data = new FormData();
          for (const key in body) {
            if (body.hasOwnProperty(key)) {
              options.data.append(key, body[key]);
            }
          }
          options.headers["X-Requested-With"] = "XMLHttpRequest";
          break;
        case CONTENT_TYPES.form:
          options.transformRequest = [
            function(data) {
              let ret = "";
              for (let it of Object.keys(data)) {
                if (ret !== "") {
                  ret += "&";
                }
                let retval = data[it] ? encodeURIComponent(data[it]) : "";
                ret += encodeURIComponent(it) + "=" + retval;
              }
              return ret;
            }
          ];
          break;
        default:
          break;
      }
    }
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const promise = new Promise((resolve, reject) => {
      options.cancelToken = source.token;
      service
        .request(options)
        .then(res => {
          if (res.status === 200) resolve(res.data);
          else reject(res);
        })
        .catch(res => {
          reject(res);
        });
    });
    promise.abort = msg => {
      source.cancel(msg !== null && msg !== undefined ? msg : null);
    };
    return promise;
  };
};
const m = (path, contentType) => {
  const str = path.split(" ");
  const method = str[0];
  let url = str[1];
  return r(`${method} ${MOCK_URI}${url}`, contentType);
};
export { r, r1, bf, gems, staticContent, arvato, m, CONTENT_TYPES };
